import { Datetime } from 'vue-datetime'
import moment from 'moment'

export default {
  name: 'FieldHorizontal',
  props: ['label', 'value', 'attrKey', 'editable', 'editAction', 'disabled', 'type'],
  components: {
    Datetime
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.editAction(this.attrKey, newValue)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldHorizontal/script.js